// extracted by mini-css-extract-plugin
module.exports = {"description":"__description__fmssk","stats":"__stats__OD0yf"};